<style scoped>
.v-text-field.v-text-field--outlined .v-input__control {
  min-height: 10px;
}

.v-label {
  font-size: 10px;
}
</style>

<template>
  <div class="d-flex flex-row justify-center">
    <div class="d-flex align-center">
      <div class="text-caption text-grey">
        {{ $t("footer.powered-by") }}
      </div>
      <v-img height="26" width="45" src="@/assets/logo.svg"> </v-img>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

